const numberFormatCache: Map<string, Intl.NumberFormat> = new Map<string, Intl.NumberFormat>();

const formatPrice = (price: number, locale: string, round: boolean = false): string => {
  let result: string;

  if (round) {
    result = Math.round(price).toString();
  } else {
    let numberFormat: Intl.NumberFormat | undefined = numberFormatCache.get(locale);

    if (numberFormat === undefined) {
      numberFormat = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      numberFormatCache.set(locale, numberFormat);
    }

    result = numberFormat.format(price);
  }

  return result;
};

export default formatPrice;
